var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        viewBox: "0 0 47 47",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("rect", {
        attrs: {
          width: "46",
          height: "46",
          transform: "translate(0.205078 0.398438)",
          fill: "white",
        },
      }),
      _c(
        "mask",
        {
          staticStyle: { "mask-type": "alpha" },
          attrs: {
            id: "mask0_906_9130",
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "47",
            height: "47",
          },
        },
        [
          _c("rect", {
            attrs: {
              x: "0.205078",
              y: "0.398438",
              width: "46",
              height: "46",
              rx: "6",
              fill: "#C4C4C4",
            },
          }),
        ]
      ),
      _c("g", { attrs: { mask: "url(#mask0_906_9130)" } }, [
        _c("path", {
          attrs: {
            d: "M0.205982 46.3945L46.2051 46.3945L46.2051 0.399925L0.205982 0.399925L0.205982 46.3945Z",
            fill: "#80CF40",
          },
        }),
        _c("path", {
          attrs: {
            d: "M46.2042 46.3997C46.2042 33.6987 35.907 23.4023 23.2047 23.4023C10.5023 23.4023 0.205078 33.6986 0.205078 46.3997H46.2042Z",
            fill: "#40A810",
          },
        }),
        _c("path", {
          attrs: {
            d: "M0.205078 0.398438C0.205078 13.0995 10.5023 23.3959 23.2047 23.3959C35.907 23.3959 46.2042 13.0996 46.2042 0.39853V0.398438H0.205078Z",
            fill: "#40A810",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }